module.exports = __webpack_public_path__ + "static/media/1.bfdd0c3a.JPG";